export const host = process.env.REACT_APP_API_URL;
export const hostImage =
  process.env.REACT_APP_IMG_URL;

export const api = {
  withAPI: `${host}`,
  withImageAPI: `${hostImage}`,
};
